import { useLocation } from 'react-router-dom';
import { normalizeSeoPath } from './urls';
import style from './homeHeading.module.css';

export const HomeHeading = () => {
  const { pathname } = useLocation();
  return normalizeSeoPath(pathname) === '/' ? (
    <h1 className={style.heading}>Доставка суши, роллов и воков от СушиВесла</h1>
  ) : null;
};
